export default {
  variants: {
    gray: {
      tdStyles:
        'text-left text-base h-20 px-3 py-6 align-middle bg-gray-100 first:rounded-bl-md first:rounded-tl-md last:rounded-br-md last:rounded-tr-md',
    },
  },
}
